{
	"ordersInfo": {
		"ticker": "Ticker",
		"option": "Option",
		"tickerCompany": "Ticker/Company",
		"operation": "Operation",
		"quantity": "Quantity",
		"sum": "Sum",
		"profitability": "Profitability",
		"dateTime": "Date/Time",
		"actions": "Actions",
		"price": "Price",
		"openedOrders": "Opened Orders",
		"statusTitle": "Status",
		"term": "Term",
		"orderStatus": "Order Status",
		"orderStatusPlaceholder": "Select Order Status",
		"orderType": "Order Type",
		"executed": "Executed",
		"averagePrice": "Average Price",
		"averageExecutedPrice": "Average Executed Price",
		"orderDuration": "Order Duration",
		"profitabilityInPercent": "Profitability (%)",
		"brokerCommission": "Broker Commission",
		"placed": "Placed Date",
		"updated": "Updated Date",
		"filled": "Filled Date",
		"canceled": "Canceled Date",
		"close": "Close",
		"stopPrice": "Stop Price",
		"limitPrice": "Limit Price",
		"avgFilledPrice": "Average filled price",
		"stopLoss": "Stop Loss",
		"takeProfit": "Take Profit",
		"pcs": "pcs",
		"orderId": "ID",
		"status": {
			"new": "New",
			"partially_filled": "Partially Filled",
			"filled": "Filled",
			"done_for_day": "Done for Day",
			"canceled": "Canceled",
			"expired": "Expired",
			"replaced": "Replaced",
			"pending_cancel": "Pending Cancel",
			"pending_replace": "Pending Replace",
			"accepted": "Processing",
			"pending_new": "Pending New",
			"rejected": "Rejected",
			"calculated": "Calculating",
			"accepted_for_bidding": "Accepted for Bidding",
			"stopped": "Stopped",
			"suspended": "Suspended",
			"held": "Held"
		},
		"side": {
			"buy": "Buy",
			"sell": "Sell",
			"sell_short": "Sell Short"
		},
		"activeOrders": {
			"filled": "Executed",
			"open": "Open",
			"canceled": "Canceled"
		},
		"types": {
			"market": "Market",
			"limit": "Limit",
			"stop": "Stop",
			"stop_limit": "Stop Limit",
			"trailing_stop": "Trailing Stop"
		},
		"attributes": {
			"stop_loss": "Stop Loss",
			"take_profit": "Take Profit"
		},
		"terms": {
			"day": "DAY",
			"gtc": "GTC",
			"opg": "OPG",
			"cls": "CLS",
			"ioc": "IOC",
			"dayPlus": "DAY+"
		}
	}
}
